import moment from "moment"
import i18n from '@/i18n';
  export function sendSuccessNotice (notice) {
    window.getApp.$emit('APP_RESOURCE_UPDATED', notice);
  }
  
  export function sendErrorNotice (notice) {
    window.getApp.$emit('APP_RESOURCE_FAILED', notice);
  }

  export function refreshResource () {
    window.getApp.$emit('REQUEST_REFRESH_DATA');
  }

  export function loadingData (value) {
    window.getApp.$emit('APP_LOADING', value);
  }

  export function buildBreadcrumb(routeName, routePath, pId, titleKey, menu, paths) {
    let breadcrumbs = [];
    // Lấy i18n instance từ window hoặc import nếu cần
    let i18n = null;
    if (typeof window !== 'undefined' && window.vm && window.vm.$i18n) {
      i18n = window.vm.$i18n;
    } else if (typeof require !== 'undefined') {
      try {
        i18n = require('@/i18n').default;
      } catch (e) {}
    }

    menu.forEach(item => {
      if (item.name === routeName) {
        breadcrumbs.push({
          text: i18n && item.titleKey ? i18n.t(`routes.${item.titleKey}`) : (item.titleKey || item.title),
          link: false,
          href: ""
        });
      } else if (item.items) {
        breadcrumbs = _.concat(breadcrumbs, buildBreadcrumb(routeName, routePath, pId, titleKey, item.items, paths))
      } else if (item.children) {
        let child = item.children.find(i => {
          return i.component === routeName;
        });
        if (child) {
          let path = _.find(paths, { name: item.name });
          breadcrumbs.push({
            text: i18n && item.titleKey ? i18n.t(`routes.${item.titleKey}`) : (item.titleKey || item.title),
            disabled: false,
            href: path ? path.path : ""
          });
          breadcrumbs.push({
            text: i18n && titleKey ? i18n.t(`routes.${titleKey}`) : (titleKey || `${child.title} (#${pId})`),
            link: false,
            href: ""
          });
        }
      }
    });
    return breadcrumbs;
  }

  export function getCurrentTime() {
    var d = new Date();
    d.setTime( d.getTime());
    return moment(d);
  }

  export function pad(num, size) {
    num = num.toString();
    while (num.length < size) num = "0" + num;
    return num;
  }

  export function makeid(length) {
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
       result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }